export default __webpack_public_path__ + "static/media/new-icon.9e6ccfa2.svg";